import React, { useEffect, useState } from "react";
import './index.css'
import { useDispatch, useSelector } from "react-redux";
import LcLoading from "../../components/Generic/LcLoading";
import Layout from "../../components/Layout/Layout";
import { SolicitationView } from "../../models/SolicitationView";
import SolicitationService from "../../services/SolicitationService/SolicitationService";
import { RootState } from "../../store";
import { PrefState } from "../../store/reducers/prefReducer";
import DynamicTableGroupColumnManagerService from "../../services/DynamicTableGroupAndColumnBuilder/DynamicTableGroupAndColumnBuilder"
import SolicitationAttendantDetails from '../Attendance/SolicitationAttendantDetails/index';
import { UserState } from "../../store/reducers/userReducer";
import SolicitationAttendantService from "../../services/SolicitationAttendantService/SolicitationAttendantService";
import { SolicitationFilterV2 } from '../../models/SolicitationFilter';
import { useHistory } from "react-router-dom";

const AttendanceDetail: React.FC = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const pref = useSelector<RootState, PrefState>(state => state.pref);

    const groupService = new DynamicTableGroupColumnManagerService();
    const solicitationAttendantService = new SolicitationAttendantService(props);
    const solicitationService = new SolicitationService(props);

    const [solicitation, setSolicitation] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [nextSolicitation, setNextSolicitation] = useState<any>();
    const [previewSolicitation, setPreviewSolicitation] = useState<any>();
    const [solicitations, setSolicitations] = useState<SolicitationView[]>([]);
    const [hasPermission, setHasPermission] = useState<boolean>(true);
    const [disabledPreview, setDisabledPreview] = useState<boolean>(false);
    const [disabledNext, setDisabledNext] = useState<boolean>(false);

    const history = useHistory();

    useEffect(() => {
        getById();
    }, [])

    const getFilterDefault = () => {
        return {
            userId: user.id,
            assunto: "0",
            customerId: "0",
            idTeam: "0",
            attendantId: "0",
            requesterId: "0",
            idStatus: "111",
            incidentId: "0",
            IdsGroupService: "0",
            IdsFilterField: "0",
            IdsService: "0",
            dataInicio: "0",
            dataFinal: "0",
            TipoData: "0",
            attendantType: "1,2",
        }
    }

    const getById = async () => {
        setLoading(true);
        setHasPermission(false);

        let id = window.location.pathname.toLowerCase().split('/attendance/');

        let filter = {
            ...getFilterDefault(),
        }

        await getSolicitationsSemLoading(filter, parseInt(id[1]));

        setLoading(false);
    }

    const getSolicitationsSemLoading = async (filter: any, id?: number) => {
        try {
            setSolicitations(pref.attendantSolicitationList || []);

            if (id) {
                filter.incidentId = id;

                if (window.location.hostname.toLowerCase().includes("localhost")) {
                    let response = await solicitationService.getSolicitationDetailById(id);
                    setSolicitation(response.data);
                    setHasPermission(true);

                    return;
                }

                try {
                    // let response;

                    // await Promise.all([
                    //     solicitationAttendantService.GetFilterMultiAdvancedV2(filter as SolicitationFilterV2),
                    //     response = solicitationService.getSolicitationDetailById(id),
                    //     //retrieveUsers(),
                    //     //retrieveWorkTypeService()
                    // ]);

                    // let response = await solicitationService.getSolicitationDetailById(id);

                    var request = {
                        solicitationId: id,
                        userId: user.id
                    }

                    var response = await solicitationAttendantService.getSolicitationDetailByIdWithCheckAutorization(request);

                    if (response.data) {
                        setSolicitation(response.data);
                        setHasPermission(true);
                    }
                }
                catch (error: any) {
                    if (error.response.data.includes("Visualização não autorizada")) {
                        setHasPermission(false);
                        setSolicitation(undefined);
                    }
                }
            }
            else {
                filter.idStatus = '102';

                const solicitationResponse = await solicitationAttendantService.GetFilterMultiAdvancedV2(filter as SolicitationFilterV2);

                let solicitationArray = solicitationResponse.data.map((solicitation, index) => {
                    return { ...solicitation, rowId: index }
                });

                setSolicitations(solicitationArray);
            }
        }
        catch (error) {
            console.warn(error);
        }
    }

    useEffect(() => {
        if (solicitation && solicitations) {
            if (solicitations.length > 0) {
                setLoading(true);

                let _nextSelection = groupService.findSolicitationNextPreviousInGroup(solicitations, solicitation.idWork, "next");
                let _previousSelection = groupService.findSolicitationNextPreviousInGroup(solicitations, solicitation.idWork, "previous");

                setNextSolicitation(_nextSelection);
                setPreviewSolicitation(_previousSelection);

                setDisabledNext(_nextSelection == null);
                setDisabledPreview(_previousSelection == null);

                setLoading(false);
            }
        }
    }, [solicitation, solicitations])

    const handleChangeSolicitation = (next: boolean) => {
        history.push(`/Attendance/${(next) ? nextSolicitation.id : previewSolicitation.id}`);
        getById();
    }

    return (
        <Layout invisible={true}>
            <div className={"attendantDetail"}>
                <LcLoading loading={loading} label={"Carregando..."}>
                    {
                        hasPermission
                            ? <SolicitationAttendantDetails
                                solicitation={solicitation}
                                disabledPreview={disabledPreview}
                                disabledNext={disabledNext}
                                previewSolicitation={previewSolicitation}
                                nextSolicitation={nextSolicitation}
                                nextButton={() => handleChangeSolicitation(true)}
                                previousButton={() => handleChangeSolicitation(false)}
                            />

                            : <div className={"centralized"} style={{ height: '84vh' }}>
                                <i className={"ppi ppi-information-circle"} />
                                <span>Você não tem acesso aos chamados desta equipe. Por favor entre em contato com seu administrador. </span>
                            </div>
                    }
                </LcLoading>
            </div>
        </Layout>
    )
}

export default AttendanceDetail;